import "./PreviousSearches.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
const searches = [
  "pizza",
  "burger",
  "cookies",
  "juice",
  "biriyani",
  "salad",
  "ice cream",
  "lasagna",
  "pudding",
  "soup",
];

function PreviousSearches() {
  return (
    <div className="previous-searches section">
      <h2>Previous Searches</h2>
      <div className="previous-searches-container">
        {searches.map((search) => (
          <div className="search-item">{search}</div>
        ))}
      </div>
      <div className="search-box">
        <input type="text" placeholder="Search for a recipe..." />
        <button className="btn">
          <FontAwesomeIcon icon={faSearch} />
        </button>
      </div>
    </div>
  );
}

export default PreviousSearches;
